import React from 'react';
import Checkbox from '@mui/material/Checkbox';

export default function CheckBox({ name, tick, onCheck }) {
  return (
    <Checkbox
      checked={tick}
      onChange={onCheck}
      disabled={name === 'gouvernance-gray'}
      inputProps={{ 'aria-label': name }}
      sx={{
        p: 0, // remove padding
        m: 0, // remove margin
        verticalAlign: 'middle',
      }}
    />
  );
}
